<template>
  <div class="text-center">
    <v-card class="list-area-box">
      <v-list class="list-area">
        <v-list-item>
          <v-list-item-title>선택</v-list-item-title>
          <v-list-item-subtitle> {{ gntNm }} </v-list-item-subtitle>
        </v-list-item>

          <v-list-item v-show="codeShow">
            <v-list-item-title>대상자명</v-list-item-title>
            <v-list-item-subtitle> {{ codeNm }} </v-list-item-subtitle>
          </v-list-item>
        <v-list-item class="stdOnly hide">
          <v-list-item-title>기준일</v-list-item-title>
          <v-list-item-subtitle> {{ occYmd }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item v-show="sYmdShow">
          <v-list-item-title>신청 시작일</v-list-item-title>
          <v-list-item-subtitle> {{ sYmd }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item v-show="eYmdShow">
          <v-list-item-title>신청 종료일</v-list-item-title>
          <v-list-item-subtitle> {{ eYmd }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item v-show="dayTypeShow">
          <v-list-item-title>오전/오후</v-list-item-title>
          <v-list-item-subtitle> {{ dayTypeNm }} </v-list-item-subtitle>
        </v-list-item>
        <span v-show="dayShow">
        <v-list-item>
          <v-list-item-title>총일수</v-list-item-title>
          <v-list-item-subtitle> {{ holDay }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>적용일수</v-list-item-title>
          <v-list-item-subtitle> {{ closeDay }} </v-list-item-subtitle>
        </v-list-item>
        </span>
        <span v-show="hourSHow">
        <v-list-item>
          <v-list-item-title>시작시간</v-list-item-title>
          <v-list-item-subtitle> {{ reqSHm }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>종료시간</v-list-item-title>
          <v-list-item-subtitle> {{ reqEHm }} </v-list-item-subtitle>
        </v-list-item>
        </span><br>
        <v-list-item>
          <v-list-item-title>신청시간</v-list-item-title>
          <v-list-item-subtitle> {{ requestHour }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item>
          <v-list-item-title>대리 업무자</v-list-item-title>
          <v-list-item-subtitle> {{ subSabunNm }} </v-list-item-subtitle>
        </v-list-item>
        <v-list-item v-show="noteYnShow">
          <v-list-item-title>신청 사유</v-list-item-title>
          <v-list-item-subtitle> {{ gntReqReson }} </v-list-item-subtitle>
        </v-list-item>
      </v-list>
    </v-card>

  </div>
</template>
<script>
import {
  getVacationDetail,
  getVacationAppDetGntCdListDetail,
  getTimeCdMgr,
} from '@/api/workStatus';
import { mapMutations, mapGetters } from 'vuex';
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **
import ViewerBottomBtn from '@/components/application/buttons/ViewerBottomBtn.vue';
import routerNames from '@/const/routerConstants';
import { getUiInfo } from '@/api/approvalCommon';

export default {
  mixins: [dialogMixin],
  data: () => ({
    gntCd: '',
    gntNm: '',
    restCnt: '',
    restCntTime: '',
    occYmd: '',
    sYmd: '',
    eYmd: '',
    holDay: '',
    closeDay: '',
    reqSHm: '',
    reqEHm: '',
    requestHour: '',
    subSabunNm: '',
    gntReqReson: '',
    dayTypeNm: '',
    dayShow: true,
    hourSHow: false,
    dayTypeShow: false,
    eYmdShow: true,
    sYmdShow: true,
    cancelView: false,
    codeShow: false,
    codeNm: '',
    noteYnShow: true,
  }),
  props: {
    appInfoParam: Object,
  },
  computed: {
    ...mapMutations('DIALOG', ['SET_DIALOG_PARAM', 'TOGGLE_MODAL']),
    ...mapGetters([
      'GET_GNT',
    ]),
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_BOTTOM_NAV
      }px`;
    },
  },

  methods: {
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),

    async cancel() {
      /*
      this.$router.push({
        name: routerNames.HolReplaceCancelSubView,
        params: this.appInfoParam,
      });
      */

      this.$store.commit('SET_APPL_SEQ', this.appInfoParam.applSeq);
      /*
      const applParam = {
        applCd: '311',
      };

      await this.$store.dispatch('ELA/FETCH_MENU_ACTION', applParam);
      */
      this.$store.commit('DIALOG/TOGGLE_MODAL', 'application_viewer');
      //this.$store.commit('DIALOG/TOGGLE_MODAL', modalNm);
      this.$router.push({
        name: routerNames.VacationCancelView,
        params: this.appInfoParam,
      });
    },

    init() {

      //현재 근태코드의 근태신청유형
      var reqUseType = this.GET_GNT.requestUseType;
      var baseCnt    = this.GET_GNT.baseCnt;

      //최소, 최대 기준일수를 보여줌
      this.baseCnt = baseCnt;
      this.maxCnt = this.GET_GNT.maxCnt;

      //기준일 체크 시
      if (this.GET_GNT.applChkYn === "Y"){
        this.codeShow = true;
        $(".stdOnly").show();
        $(".stdOnly b").text(this.GET_GNT.applStdNm !== ""?this.GET_GNT.applStdNm:"기준일");

        if (this.GET_GNT.useSdateCnt !== "" && this.GET_GNT.useEdateCnt !== "" && this.GET_GNT.useSdateCnt !== null && this.GET_GNT.useEdateCnt != null){
          $("#stdInfo").text("( D-"+this.GET_GNT.useSdateCnt+" ~ D+"+this.GET_GNT.useEdateCnt+" )");
        }
      }else{
        this.codeShow = false;
        $(".stdOnly").hide();
      }

      //근태신청유형에 따라 신청폼을 바꿔주는 화면컨트롤 로직
      //발생휴가 사용인 경우 잔여 표기
      if (this.GET_GNT.vacationYn === "Y"){
        $("#restDayCnt").show();
      }else{
        $("#restDayCnt").hide();
      }

      //휴가형태에 따라
      if( reqUseType == "D" ) {//종일인 경우
        this.dayShow = true;
        this.hourSHow = false;
        this.eYmdShow = true;
        this.dayYn = "Y";
        this.dayTypeShow = false;

      } else {

        this.dayShow = false;
        this.hourSHow = true;
        this.eYmdShow = false;
        this.dayYn = "N";

        if (this.GET_GNT.baseCnt === this.GET_GNT.maxCnt){	//시간 고정인 경우
          this.requestHourReadOnly = true;
        }else{
          this.requestHourReadOnly = false;
        }

        if(reqUseType != "H"){
          this.dayTypeShow = false;
          this.dayTypeDisabled = true;
          this.dayType = reqUseType;
        }else{
          this.dayTypeShow = true;
          this.dayTypeDisabled = false;
          this.dayType = 'AM';
        }
      }
    }
  },

  async created() {

    this.cancelView = this.appInfoParam.cancelView;
    //console.log('this.appInfoParam : '+JSON.stringify(this.appInfoParam));
    let response = await getVacationDetail(this.appInfoParam);

    //console.log('getVacationDetail : '+JSON.stringify(response));

    const param = {
      gntCd : response.data.data.gntCd,
    }

    this.occYmd = response.data.data.occYmd;
    this.sYmd = response.data.data.sYmd;
    this.eYmd = response.data.data.eYmd;
    this.holDay = response.data.data.holDay;
    this.closeDay = response.data.data.closeDay;
    this.reqSHm = response.data.data.reqSHm!==null?response.data.data.reqSHm.substring(0, 2)+':'+response.data.data.reqSHm.substring(2, 4):'';
    this.reqEHm = response.data.data.reqEHm!==null?response.data.data.reqEHm.substring(0, 2)+':'+response.data.data.reqEHm.substring(2, 4):'';
    this.requestHour = response.data.data.requestHour;
    this.subSabunNm = response.data.data.subSabunNm;
    this.gntReqReson = response.data.data.gntReqReson;
    this.dayTypeNm = response.data.data.dayType==='AM'?'오전':'오후';
    this.codeNm = response.data.data.targetInfo;

    response = await getVacationAppDetGntCdListDetail(param);
    console.dir(response);
    this.$store.commit('SET_GNT', response.data.data);
    this.gntNm = response.data.data.codeNm;
    this.gntCd = response.data.data.code;
    this.init();
    this.OFF_APP_SPINNER();

    param.searchGntCd = param.gntCd;
    response = await getTimeCdMgr(param);

    //console.dir('getTimeCdMgr : '+JSON.stringify(response));
    if (response.data.data.fileYn === 'N') {
      this.$emit('showFileView', false);
    } else {
      this.$emit('showFileView', true);
    }

    if (response.data.data.noteYn === 'N') {
      this.noteYnShow = false;
    } else {
      this.noteYnShow = true;
    }

    //20260518 출산전후휴가(미숙아) 추가 92번
   if( this.appInfoParam.viewerType === 'applConfirm' && (this.gntCd === '90' || this.gntCd === '91' || this.gntCd === '92'|| this.gntCd === '320') ){

     if(confirm('육아휴직을 동시에 신청하시겠습니까?')){
     
      this.$store.commit('SET_CODE', '151');
      this.$store.commit('SET_APPL_CD', '151');
      this.$store.commit('SET_TIM_APPL_SEQ', this.appInfoParam.applSeq);

        const applParam = {
        applCd: '151',
        searchApplCd: '151',
      };

       let routerName = await this.$store.dispatch(
        'ELA/FETCH_MENU_ACTION',
        applParam,
      );

      this.$router.push(routerName);

      }
   }

  },

  components: { ViewerBottomBtn },
};
</script>
